export { default } from "./SimilarPlayersFilterContentView";
